export const SET_LOGGED = 'set_logged';

export const setLogged = (logged) => ({ type: SET_LOGGED, logged });
